export default function error(message, title = this.translate("LBL_ERROR")) {
  const data = {
    color: "red",
    header: title,
    buttons: [{ label: this.translate("LBL_CLOSE_POPUP"), callback: () => this.popupHide() }],
  };
  this.popup(message, data);
}
